/* globals Swiper */
import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import { sliderPagination } from '~/js/helpers';

const featuredItems = [...document.querySelectorAll('.featured-items')];

featuredItems.forEach((featuredItem) => {
	const featuredSlider = featuredItem.querySelector('.swiper-featured-items');
	if (!featuredSlider) return;

	const slidesPerView = Number(featuredSlider.dataset.swiperColumns) || 4;
	const navigation = featuredItem.querySelector('.swiper-navigation');

	// Determine the default gap value from CSS variables or fallback to a default value
	var style = window.getComputedStyle(document.body);
	let defaultGap = style.getPropertyValue('--gap-auto');
	if (defaultGap && defaultGap.includes('rem')) {
		const remValue = parseFloat(defaultGap);
		const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
		defaultGap = `${remValue * rootFontSize}px`;
	}
	if (!defaultGap || defaultGap.trim() === '') {
		defaultGap = '32px';
	}

	new Swiper(featuredSlider, {
		modules: [Navigation, Pagination, A11y, Mousewheel],
		a11y: true,
		grabCursor: true,
		loop: false,
		slidesPerView: 1.05,
		spaceBetween: defaultGap,
		keyboard: {
			enabled: true,
		},
		navigation: {
			nextEl: featuredSlider.querySelector('.swiper-button-next'),
			prevEl: featuredSlider.querySelector('.swiper-button-prev'),
		},
		pagination: sliderPagination(featuredSlider.querySelector('.swiper-pagination')),
		breakpoints: {
			760: { slidesPerView, spaceBetween: 32 },
			1024: { slidesPerView },
		},
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		on: {
			lock: () => {
				navigation.style.display = 'none';
			},
			unlock: () => {
				navigation.style.display = 'flex';
			},
		},
	});
});
